import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Grid } from "@/components/Grid";
import { Heading } from "@/components/Heading";

import { ContactForm } from "./ContactForm";
import { IInspectorContactSection } from "./types";

export const InspectorContactSection: React.FC<IInspectorContactSection> = ({
  title,
  description,
}) => {
  const { bp, colors } = useTheme();
  const { css } = useFela();

  return (
    <Grid
      customStyle={{
        flexDirection: "column",
        padding: "40px 20px",
        [bp.FROM_DESKTOP]: {
          padding: "80px 20px",
        },
      }}
      wrapperStyle={{ backgroundColor: colors.GHOST_WHITE }}
    >
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        })}
      >
        <Heading
          as="h3"
          customStyle={{
            fontSize: 28,
            lineHeight: "36px",
            marginBottom: 10,
            color: colors.DARK_GREY,
            fontWeight: 700,
            textAlign: "center",
            [bp.FROM_DESKTOP]: {
              maxWidth: 850,
              fontSize: 36,
              lineHeight: "46px",
            },
          }}
        >
          {title}
        </Heading>
        <p
          className={css({
            textAlign: "center",
            fontSize: 14,
            lineHeight: "22px",
            color: colors.GRAY,
            marginBottom: 30,
            [bp.FROM_TABLET]: {
              maxWidth: 630,
              marginBottom: 60,
            },
          })}
        >
          {description}
        </p>

        <ContactForm />
      </div>
    </Grid>
  );
};
